<div *ngIf="noResultsText && (!jobs || jobs.length == 0) && !busy" class="no-jobs">
  <div style="table: cell; vertical-align: middle">{{ noResultsText }}</div>
</div>

<div *ngIf="!noResultsText && subWord && (!jobs || jobs.length == 0) && !busy" class="no-jobs">
  <div style="table: cell; vertical-align: middle">No {{ subWord }} jobs</div>
</div>

<div *ngIf="busy" class="center-block"><i class="fa fa-spinner fa-spin"></i> Loading...</div>

<div *ngIf="!busy && jobs && jobs.length > 0">
  <div class="flex w-100 flex-wrap">
    <div class="flex-grow-1" style="overflow-y: auto; height: 330px; margin-right: 10px">
      <ng-container [ngTemplateOutlet]="jobsT"></ng-container>
    </div>
    <div style="min-height: 330px; width: 640px">
      <div *ngIf="interactiveMap" class="w-full h-full">
        <tasks-map
          [tasks]="mapControlTasks"
          [selectedTaskId]="selectedTaskId"
          [mapOptions]="{ streetViewControl: false }"
        ></tasks-map>
      </div>
      <div style="position: relative" *ngIf="!interactiveMap" (click)="interactiveMap = true">
        <img [src]="staticMapSrc" alt="" class="map-image" />
      </div>
    </div>
  </div>
</div>

<ng-template #jobsT>
  <div
    (click)="selectJob(job)"
    *ngFor="let job of jobs"
    [ngClass]="{
      'job-container-selected': selectedJob == job,
      'job-container': selectedJob != job
    }"
    style="cursor: pointer"
  >
    <div class="flex">
      <div class="flex-grow-1">
        <div class="job-number" (click)="selectJob(job)">
          <a href="/app/jobscreen/{{ job.id }}" target="_blank">{{
            isCustomerView ? job.orderNumber : job.jobNumber
          }}</a>
          <span style="margin-left: 5px; vertical-align: text-bottom">
            <img src="/assets/images/telephony/leave-page-icon.svg" />
          </span>
        </div>
        <div class="sub-heading-section">
          <span *ngIf="!isCustomerView"
            >Supplier Price:
            {{ (job.price | currency : 'GBP' : 'symbol' : '1.2-2') || 'N/A' }}
            <span style="padding: 5px">/</span>
            <span>
              Distance:
              <span class="bold-values">{{ job.totalDistance | number : '1.1-1' }}</span> miles
            </span>
          </span>
          <span *ngIf="isCustomerView">
            <span class="sub-title">Dept:</span>
            <span class="sub-heading">{{ job.orderedByDept }}</span>
            <span class="sub-title">Team:</span>
            <span class="sub-heading">{{ job.orderedByTeam }}</span>
            <span class="sub-title">User:</span>
            <span class="sub-heading">
              <a href="/app/vmeuserdetails/{{ job.orderedByUserId }}?orgTypeId=1" target="_blank">{{
                job.orderedByUser
              }}</a>
            </span>
          </span>
        </div>
      </div>

      <div
        class="flex-shrink-1"
        style="align-content: center; padding: 10px"
        *ngIf="telephonyService.AnonCallLoggable$ | async"
      >
        <button (click)="logCall(job)" label="Log Call" pButton></button>
      </div>
    </div>

    <div class="tasks-container">
      <div
        *ngIf="!job.tasks || job.tasks?.length == 0"
        class="center-block"
        style="font-weight: bold; font-size: 1.2em; margin-bottom: 8px"
      >
        This job has no associated tasks
      </div>
      <div *ngFor="let task of job.tasks" class="task-info">
        <task-information-card
          [task]="task"
          [isCustomerView]="isCustomerView"
        ></task-information-card>
      </div>
    </div>
  </div>
</ng-template>
